import type { OptionItem } from './OptionGroup';
import type { ReactElement } from 'react';

import { Checkbox, RoundCheckbox } from './OptionGroupStyles';
import PhosphorCheckIcon from '~/components/shared/core/icons/PhosphorCheckIcon';

type FilterCheckboxProps = {
  item: OptionItem;
  checkboxType?: string;
  getIconColor?: (bg?: string) => string | undefined;
};

export const FilterCheckbox = ({
  item,
  checkboxType,
  getIconColor,
}: FilterCheckboxProps): ReactElement | null => {
  switch (checkboxType) {
    case 'round':
      return <RoundCheckbox $selected={item.selected} />;
    case 'square':
      return (
        <Checkbox $checked={item.selected} $bgColor={item.bgColor || 'transparent'}>
          <PhosphorCheckIcon className="checkIcon" color={getIconColor?.(item.bgColor)} />
        </Checkbox>
      );
    default:
      return null;
  }
};
